// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__TTmwa","footer":"ModalInfo_footer__jUs7J"};